<template>
  <div class="video-agreement">
    <div class="video-agreement__wrapper">
      <div v-if="interview.company && !!interview.company.logo" class="logo">
        <img :src="interview.company.logo" alt="" />
      </div>

      <bad-browser v-if="badBrowser" :locale="locale" />

      <template v-else>
        <div class="info">
          <div class="title">{{ videoTitle ? videoTitle : $tr('interview.landing.modules.videointerview.title') }}</div>

          <div v-if="videoDecription !== null" class="desc" v-html="videoDecription.replace(/\n/g, '<br>')"></div>
        </div>

        <vbutton :label="$tr('interview.tests.init.button.start')" @click="$emit('input', true)" />

        <agree-text-default v-if="!isAgreementAlreadyAccepted" class="agree" :country="vacancyCountry" has-video />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BadBrowser from '@/components/interview/BadBrowser';
import IEBrowserDetector from '@/components/mixin/IEBrowserDetector.js';
import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
import AgreeTextDefault from '@/routes_new/outer/interview/landing/components/agree-text/index';

export default {
  name: 'VideoAgreement',

  components: {
    BadBrowser,
    AgreeTextDefault
  },

  mixins: [IEBrowserDetector, SafariBrowserDetector],

  props: {
    interview: {
      type: [Object, Array],
      default: () => {}
    },

    isAgreementAlreadyAccepted: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('locale', { locale: 'current' }),

    ...mapGetters('landing', ['vacancyCountry']),

    videoTitle() {
      if (!this.interview && !this.interview.active_modules) return '';

      return this.interview.active_modules.filter(i => i.id === 'videointerview')[0].name;
    },

    videoDecription() {
      if (!this.interview && !this.interview.active_modules) return false;

      return this.interview.active_modules.filter(i => i.id === 'videointerview')[0].description;
    },

    badBrowser() {
      if (this.isIE11OrOlder || this.defineRecordingFlow === 'notallowed') return true;

      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.video-agreement {
  background-color: #e5e5e5;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 2vw 0;
  min-width: 320px;

  &__wrapper {
    position: relative;
    background-color: #fff;
    max-width: 800px;
    padding: 50px 5vw;
    box-sizing: border-box;
    margin: auto 0;
    min-width: 320px;
    width: 100%;
  }
}

.logo {
  height: 60px;
  max-height: 60px;
  min-height: 60px;
  margin-bottom: 30px;

  img {
    height: 100%;
  }
}

.info {
  margin-bottom: 30px;

  .title {
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 28px;
    margin-bottom: 30px;
  }

  .description {
    font-style: normal;
    font-weight: normal;
    line-height: 22px;
    font-size: 15px;
  }
}

.agree {
  margin-top: 20px;
  line-height: 1.4;
  color: #9faab6;
  font-size: 13px;

  ::v-deep a {
    color: #9faab6;
    text-decoration: underline;

    &:hover {
      color: $green-hover;
    }
  }
}
</style>
